module.exports = __webpack_public_path__ + "3cf620d9f1db1057948ca29c96d0221c.svg";